import React, { useState } from 'react'
import { ImportTouchDesk } from 'modules/ImortTouchDesk'
import { useProfileStore } from 'context/ProfileStore'
import AddEditAccessesModal from './modals/AddEditAccesses.modal'

const Superset = () => {
  const { profileStore } = useProfileStore()
  const [modal, setModal] = useState({
    open: false,
    data: null
  })

  const onOpenModal =
    (data = null) =>
    () => {
      setModal({
        open: true,
        data
      })
    }

  const componentProps = {
    accessList: profileStore?.superset?.accessList || [],
    onAdd: onOpenModal(null),
    onEdit: onOpenModal
  }
  return (
    <>
      <ImportTouchDesk
        desktop={() => import('./layout/Superset.desktop')}
        touch={() => import('./layout/Superset.mobile')}
      >
        {Component => <Component {...componentProps} />}
      </ImportTouchDesk>
      {modal.open && (
        <AddEditAccessesModal
          open={modal.open}
          onClose={() => setModal({ open: false, data: null })}
          data={modal.data}
        />
      )}
    </>
  )
}
export default Superset
